import { Box } from '@atgfr8/atg-ui-tailwind';
import { Show } from 'solid-js';

interface StarProps {
  filled: boolean;
  onClick?: () => void;
  sx?: Record<string, string>;
  class?: string;
}

const Star = (props: StarProps) => (
  <span
    class={`star ${props.filled ? 'filled' : 'unfilled'}  `}
    style={props.sx}
  >
    {props.filled ? '★' : '☆'}
  </span>
);

export interface RatingProps {
  currentRating: number;
  starCount: number;
  numberOfRatings: number | undefined;
  ratingClass?: string;
  onChange?: (newRating: number) => void;
  showCount: boolean;
  small?: boolean;
}

const renderStars = (currentRating: number, starCount: number) => {
  return Array.from({ length: starCount }, (_, index) => {
    const starIndex = index + 1;
    return (
      <Star filled={starIndex <= currentRating} sx={{ color: '#FF9800' }} />
    );
  });
};

export const StarRating = (props: RatingProps) => {
  return (
    <Box class="flex flex-col">
      <Box>{renderStars(props.currentRating, props.starCount)}</Box>
      <Show when={props.showCount}>
        <Box fontSize={Boolean(props.small) ? '12px' : undefined}>{`${
          props.numberOfRatings ?? 0
        } Ratings`}</Box>
      </Show>
    </Box>
  );
};
